import React, { useContext, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AuthContext from "../auth/AuthContext";
import FieldGuideNavigation from "./FieldGuideNavigation";
import "../style/Sidebar.css";

const Sidebar = ({ isMobileMenuOpen, setIsMobileMenuOpen, isMobile, onMenuToggle, isCollapsed, onToggleCollapse }) => {
  const { auth, user } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();
  const sidebarRef = useRef(null);

  const isActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(path);
  };


  // Handle window resize to detect mobile/desktop - handled in parent

  // Close menu on route change (mobile only)
  useEffect(() => {
    if (isMobile) {
      setIsMobileMenuOpen(false);
    }
  }, [location.pathname, isMobile, setIsMobileMenuOpen]);

  // Close menu when clicking outside (mobile only)
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isMobile &&
        isMobileMenuOpen &&
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        !event.target.closest(".burger-menu-button") &&
        !event.target.closest(".top-bar")
      ) {
        setIsMobileMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isMobile, isMobileMenuOpen, setIsMobileMenuOpen]);


  const handleNavClick = () => {
    if (isMobile) {
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <>
      {/* Backdrop Overlay - Mobile Only */}
      {isMobile && isMobileMenuOpen && (
        <div
          className="sidebar-backdrop"
          onClick={() => setIsMobileMenuOpen(false)}
          aria-hidden="true"
        ></div>
      )}

      {/* Sidebar */}
      <aside
        ref={sidebarRef}
        className={`sidebar ${isMobileMenuOpen ? "sidebar-open" : ""} ${isCollapsed && !isMobile ? "sidebar-collapsed" : ""}`}
      >
      <nav className="sidebar-nav">
        {auth?.user ? (
          <>
            <div className="nav-section">
              <h3 className="nav-section-title">Contents</h3>
              
              <FieldGuideNavigation onNavClick={handleNavClick} />
              
              <Link 
                to="/crops" 
                className={`nav-link ${isActive('/crops') ? 'active' : ''}`}
                onClick={handleNavClick}
              >
                Crop Catalog
              </Link>
              
              <Link 
                to="/recipes" 
                className={`nav-link ${isActive('/recipes') ? 'active' : ''}`}
                onClick={handleNavClick}
              >
                Recipes
              </Link>
              
              <Link 
                to="/gardens" 
                className={`nav-link ${isActive('/gardens') ? 'active' : ''}`}
                onClick={handleNavClick}
              >
                Gardens
              </Link>
              
              {user?.preferred_garden && (
                <Link 
                  to={`/gardens/${user.preferred_garden.garden_uuid}`}
                  className={`nav-link preferred-garden ${isActive(`/gardens/${user.preferred_garden.garden_uuid}`) ? 'active' : ''}`}
                  onClick={handleNavClick}
                >
                  ⭐ {user.preferred_garden.name}
                </Link>
              )}
            </div>
          </>
        ) : (
          <div className="nav-section">
            <h3 className="nav-section-title">Access</h3>
            
            <Link 
              to="/login" 
              className={`nav-link ${isActive('/login') ? 'active' : ''}`}
              onClick={handleNavClick}
            >
              Login
            </Link>
            
            <Link 
              to="/register" 
              className={`nav-link ${isActive('/register') ? 'active' : ''}`}
              onClick={handleNavClick}
            >
              Register
            </Link>
          </div>
        )}
      </nav>

      <div className="sidebar-footer">
        <div className="ornamental-divider"></div>
        <div className="footer-links">
          <Link to="/about" className="footer-link" onClick={handleNavClick}>
            About
          </Link>
          <Link to="/privacy-policy" className="footer-link" onClick={handleNavClick}>
            Privacy Policy
          </Link>
        </div>
      </div>
    </aside>
    </>
  );
};

export default Sidebar;
